var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftIon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 10.92H6.48002L11.76 5.52C12.24 5.04 12.24 4.32 11.76 3.84C11.28 3.36 10.56 3.36 10.08 3.84L2.88002 11.28C2.40002 11.76 2.40002 12.48 2.88002 12.96L10.08 20.4C10.32 20.64 10.68 20.76 10.92 20.76C11.28 20.76 11.52 20.64 11.76 20.4C12.24 19.92 12.24 19.2 11.76 18.72L6.48002 13.32H20.4C21.12 13.32 21.6 12.84 21.6 12.12C21.6 11.4 21.12 10.92 20.4 10.92Z",
    fill: "#858894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIon);
export default __webpack_public_path__ + "static/media/arrow_left_ion.51ff8ebfb4519624f7f43e825629f0a4.svg";
export { ForwardRef as ReactComponent };